<app-loading *ngIf="isLoading$ | async"></app-loading>

<mat-form-field class="app-project-list-search app-block">
  <mat-label i18n>Search</mat-label>
  <input matInput i18n-placeholder placeholder="Find by name" [(ngModel)]="searchTerm">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<mat-selection-list [multiple]="false">
  <mat-list-option *ngFor="let project of (projects$ | async) | projectFilter: searchTerm" (click)="select(project)">
    <h4 mat-line i18n-title title="Open Design">{{project.name}}</h4>
  </mat-list-option>
</mat-selection-list>
